import './customers.css';
import React, { useState, useEffect} from 'react';

import BackgroundImg from '../../../../components/backgroundImg/backgroundImg'
import CustomerBackground from '../../../../assets/sectionBackgrounds/customerBackground/customerBackground';
import jasonImg from '../../../../assets/images/jason.jpeg';
import IconsBackground from '../../../../assets/icons/iconsBackground/iconsBackground';
import Arrow from '../../../../assets/icons/arrows/arrow';
import StarReader from './starReader/starReader';

const API_BASE = window.location.hostname === 'localhost' 
  ? 'http://expensible.cloud' 
  : '';

export default function Customers({isMobile}) {

    const [counter, setCounter] = useState(0)

    const [customerReviews, setCustomerReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    try {
    useEffect(() => {
        // Requesting the table from the api
        fetch(`${API_BASE}/express/api/customer_reviews`)
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    setCustomerReviews(result.data);
                    setLoading(false);
                    console.log('the api connected 200 ok', result.data);
                }
                //setLoading(false);
                console.log('no result',result)
            })
            .catch((err) => console.error("Error fetching data:", err));
    }, []);
} catch (err) {
    console.log(err)
}

    //console.log(customerReviews[0]); 

    const clickRight = () => {
        setCounter((counter + 1) % 5)
    }

    const clickLeft = () => {
        setCounter((counter - 1 + 5) % 5)
    }

    return(
        <div className="customers">
            <div>
                <BackgroundImg background={<CustomerBackground isMobile={isMobile}/>} customClass={'customer-background'}/>
                <div className="customers-title">

                    <div className="customer-img-icon">
                        <div>
                            <IconsBackground/>
                            <img src={jasonImg} alt="customer testimonial" className="customer-img"/>
                        </div>
                    </div>
                    
                    <h2>What customers say about Expensable</h2>

                </div>
                {loading ? 

                <div className="customers-content-background">
                    <div>
                        <StarReader/>
                    </div>
                    <div className="customer-name-and-title">
                        <p>Loading...</p>
                    </div>
                    <div>
                        <p>“Loading...”</p>
                    </div>
                    <div className="customer-arrows">
                        <Arrow point={true} onClick={clickRight}/>
                        <Arrow point={false}/>
                    </div>
                </div>
                
                : 
                
                <div className="customers-content-background">
                    <div>
                        <StarReader rating={customerReviews[counter].customer_rating}/>
                    </div>
                    <div className="customer-name-and-title">
                        <p>{customerReviews[counter].customer_name}, {customerReviews[counter].customer_title} — {customerReviews[counter].customer_company}</p>
                    </div>
                    <div>
                        <p>“{customerReviews[counter].customer_testimonial}”</p>
                    </div>
                    <div className="customer-arrows">
                        <Arrow point={true} onClick={clickLeft}/>
                        <Arrow point={false} onClick={clickRight}/>
                    </div>
                </div>

                }
                <div className="customer-counter">
                    <p> {counter + 1} / 5 </p> 
                </div>
            </div>
        </div>
    )
}